var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        _vm._l(_vm.lavorazioni, function (lav, i) {
          return _c(
            "v-flex",
            { key: i, attrs: { xs12: "", sm6: "", md4: "" } },
            [
              _c("CardLavorazione", {
                attrs: { lavorazione: lav, compact: _vm.compact },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }